module.exports = __webpack_public_path__ + "img/3.23cb9d53.svg";